export const getClientUrl = () => {
  return typeof window !== "undefined" && window?.location?.href ? new URL(window.location.href) : null;
};
